import React, { useEffect } from "react";
import { Provider, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PersistGate } from "redux-persist/integration/react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { create } from "jss";
import rtl from "jss-rtl";
import { StylesProvider, jssPreset } from "@mui/styles";
import { store, persistor } from "./store";
import "./assets/fonts/Yekan-Font-master/stylesheet.css";
import "./assets/fonts/iransans/fonts.css";
import "animate.css/animate.min.css";
import "./assets/css/rest.css";
import "./assets/css/main.css";
import RouterComponent from "./routes";
import Master from "./components/Layouts/master";
import { faIR } from "@mui/material/locale";
import { logBuildInfo } from "./utils/buildInfo";

const theme = createTheme({
  direction: "rtl",
  faIR,
  typography: {
    fontFamily: "iransans",
    fontSize: 13,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        outlinedSecondary: {
          color: "#c2af20",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          marginLeft: 3,
        },
      },
    },
  },
});
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

const AppContent = () => {
  const login = useSelector((state) => state.authReducer.login);

  // Log build info on app startup
  useEffect(() => {
    logBuildInfo();
  }, []);

  return (
    <>
      {login ? (
        <Master>
          <RouterComponent />
        </Master>
      ) : (
        <RouterComponent />
      )}
      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl
        pauseOnVisibilityChange
        draggable={false}
        pauseOnHover
      />
    </>
  );
};

function App() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <StylesProvider jss={jss}>
          <ThemeProvider theme={theme}>
            <AppContent />
          </ThemeProvider>
        </StylesProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
